module.exports = __webpack_public_path__ + "img/impact-landing2.823fd960.png";